import {Component, inject} from '@angular/core';
import {LogoComponent} from '../../../../shared/components/logo/logo.component';
import {TranslocoPipe} from '@jsverse/transloco';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {Router} from '@angular/router';
import {AppointmentSelectionService} from '../../../appointment-selection/appointment-selection.service';

@Component({
  selector: 'app-success',
  imports: [
    LogoComponent,
    TranslocoPipe,
    TextButton
  ],
  templateUrl: './success.component.html',
  styleUrl: './success.component.scss'
})
export class SuccessComponent {
  router = inject(Router);
  appointmentSelectionService = inject(AppointmentSelectionService);

  bookAppointment() {
    this.appointmentSelectionService.resetTimeSelection();
    this.router.navigate(['/appointment-selection']);
  }

  manageAppointments() {
    this.router.navigate(['/profile/appointments']);
  }
}
